/**
 * Flashadz configuration, the single source of truth.
 * Change a value here and it changes everywhere (UI + workers). Nothing
 * brand-specific should be hardcoded anywhere else.
 */

export const APP_NAME = "Flashadz";

export const APP_TAGLINE = "Ads that pay for themselves.";

// ── Partner program + attribution defaults ───────────────────────────
// What a new product's partner program starts from: a 20% reward paid on every
// recurring sale, cleared after a 30 day hold, a 30 day cookie window, a $50
// minimum payout, and no first-sale bonus. Per-product settings can override.
export const REWARD_DEFAULTS = {
  type: "percent",
  value: 20,
  duration: "recurring",
  holdDays: 30,
  cookieDays: 30,
  minPayoutCents: 5000,
  bonusFirstSaleCents: 0,
} as const;

/** How a referral is credited: the last click inside the window wins. */
export const ATTRIBUTION = {
  model: "last_click",
  windowDays: 30,
} as const;

// ── Partner portal chrome ────────────────────────────────────────────
export const PARTNER_PORTAL = {
  chromeName: "Partner Portal",
  poweredBy: "powered by Flashadz",
  /** Where partners join and sign in. */
  url: "https://partners.flashsuite.ai",
} as const;

// ── Stripe (real billing) ────────────────────────────────────────────
/**
 * Flashadz's one price on the shared Stripe account (made by scripts/stripe-catalog, tagged
 * metadata.app=flashadz; ids are not secret): the fee, metered at 1 cent per unit, and the meter
 * the fee sweep reports each business's fee to, in cents.
 */
export const STRIPE = {
  feePriceId: "price_1U6MVsLpztlP1nsa7XgcvABM",
  feeMeterEvent: "flashadz_ad_spend_fee",
} as const;
